export default "__VITE_ASSET__BtrzqK02__"